import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'moment/locale/en-gb';

import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';

class _DatePickerInput extends React.Component {
  static propTypes = {
    forwardedRef: PropTypes.any,
    touched: PropTypes.any,
    errors: PropTypes.any,
    handleChange: PropTypes.any,
    handleBlur: PropTypes.any,
    values: PropTypes.any,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    help: PropTypes.string,
    HTMLname: PropTypes.string.isRequired,
    value: PropTypes.any,
    onClick: PropTypes.func
  };

  render() {
    const {
      HTMLname,
      placeholder,
      className,
    } = this.props;

    return (
      <div className="m-input-icon m-input-icon--right">
        <input
          ref={this.props.forwardedRef}
          {...this.props}
          className={'form-control m-input ' + className}
          type="text"
          placeholder={placeholder}
          name={HTMLname}
          id={HTMLname}
        />
        <span className="m-input-icon__icon m-input-icon__icon--right">
          <span>
            <i className="la la-calendar" />
          </span>
        </span>
      </div>
    );
  }
}

const DatePickerInputWithForwardedRef = React.forwardRef(
  (props, ref) => <_DatePickerInput forwardedRef={ref} {...props} />
);

export { DatePickerInputWithForwardedRef as DatePickerInput };

class CustomDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment()
    };

    this._handleChange = this._handleChange.bind(this);
  }

  static propTypes = {
    touched: PropTypes.any,
    errors: PropTypes.any,
    handleChange: PropTypes.any,
    handleBlur: PropTypes.any,
    values: PropTypes.any,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string,
    help: PropTypes.string,
    setValues: PropTypes.func,
    minDate: PropTypes.object,
    maxDate: PropTypes.object,
    showMonthDropdown: PropTypes.bool,
    showYearDropdown: PropTypes.bool,
    setFieldValue: PropTypes.func
  };

  _handleChange(value) {
    this.props.setFieldValue(this.props.name, value);
  }

  render() {
    const {
      touched,
      errors,
      name,
      label,
      help,
      values,
      minDate,
      showMonthDropdown,
      showYearDropdown,
      maxDate
    } = this.props;

    const selected =
      typeof values[name] === 'object' && moment.isMoment(values[name])
        ? values[name]
        : undefined;

    return (
      <div className={
          touched[name] && errors[name]
            ? 'form-group m-form__group has-danger'
            : 'form-group m-form__group'
        }
      >
        {label && <label htmlFor={name}>{label}</label>}

        <DatePicker
          disabledKeyboardNavigation
          style={{ zIndex: 500 }}
          customInput={<DatePickerInputWithForwardedRef {...this.props} HTMLname={name} />}
          selected={selected}
          onChange={this._handleChange}
          dateFormat="DD/MM/YYYY"
          minDate={minDate}
          maxDate={maxDate}
          showMonthDropdown={!!showMonthDropdown}
          showYearDropdown={!!showYearDropdown}
          dropdownMode="select"
          placeholderText="Select a date"
        />

        {help && <span className="m-form__help">{help}</span>}

        {touched[name] && errors[name] && (
          <div className="form-control-feedback">{errors[name]}</div>
        )}
      </div>
    );
  }
}

export default CustomDatePicker;
